import { GET_CHECKOUT_STATE } from "../../../../operations/queries/operations/queries/get-checkout-state.js";
async function getCheckoutState(apolloClient, cartId, cartHash) {
  const { data, error } = await apolloClient.query({
    query: GET_CHECKOUT_STATE,
    variables: {
      getCartId: cartId
    },
    fetchPolicy: "network-only",
    context: { forwardHeaders: { "cart-hash": cartHash || null } }
  });
  if (error) {
    console.error("getCheckoutState", error);
    throw new Error(error.message);
  }
  return {
    checkoutState: data.getCart?.cart?.checkoutState
  };
}
export {
  getCheckoutState
};
//# sourceMappingURL=get-checkout-state.js.map
